import { createState } from "@tecnobit-srl/state";
import { useSsrCollector } from "@tecnobit-srl/ssr-collector";
import { Children, cloneElement, isValidElement, useEffect } from "react";
import { createPortal } from "react-dom";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/index.tsx
var { ContextProvider, useStore } = createState("Head", (set) => ({
	elements: {},
	add: (key, element) => {
		set((state) => ({
			...state,
			elements: {
				...state.elements,
				[key]: element
			}
		}));
	},
	remove: (key) => {
		set((state) => {
			const { [key]: _, ...rest } = state.elements;
			return {
				...state,
				elements: rest
			};
		});
	}
}));
function HeadProvider({ children }) {
	return /* @__PURE__ */ jsxs(ContextProvider, { children: [children, /* @__PURE__ */ jsx(HeadElements, {})] });
}
function HeadElements() {
	const elements = useStore((s) => s.elements);
	if (useSsrCollector()) return null;
	return createPortal(Object.values(elements), document.head);
}
function Head({ children, headKey }) {
	const collector = useSsrCollector();
	const { add, remove } = useStore((s) => ({
		add: s.add,
		remove: s.remove
	}));
	useEffect(() => {
		add(headKey, children);
		return () => {
			remove(headKey);
		};
	}, [
		headKey,
		children,
		add,
		remove
	]);
	if (collector) {
		const withStatic = Children.map(children, (child) => {
			if (isValidElement(child)) return cloneElement(child, { static: "" });
			return child;
		});
		collector.headElements.set(headKey, withStatic);
	}
	return null;
}
//#endregion
export { Head, HeadProvider };
